// import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import { BasicLayout, RouteView, pageLayout, UserLayout } from '@/layouts'

const constantRouterComponents = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    title: '首页',
    meta: { title: '首页' },
    redirect: '/manage/materialDirection',
    children: [
      {
        path: '/manage/planning',
        name: 'planning',
        meta: { title: '企划招募', icon: 'recruit', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/planning/planning')
      },
      {
        path: '/manage/planDetail/:id',
        name: 'planDetail',
        hidden: true,
        meta: { title: '企划详情', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/planning/planDetail')
      },
      {
        path: '/manage/planContributeInfo/:id',
        name: 'planContributeInfo',
        hidden: true,
        meta: { title: '投稿信息', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/planning/planContributeInfo')
      },
      {
        path: '/manage/planContribute/:id',
        name: 'planContribute',
        hidden: true,
        meta: { title: '投稿作品信息', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/planning/planContribute')
      },
      {
        path: '/manage/chartlet',
        name: 'chartlet',
        meta: { title: '素材管理', icon: 'pic', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/chartlet')
      },
      {
        path: '/manage/person',
        name: 'person',
        meta: { title: '人物素材管理', icon: 'clothes', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/person')
      },
      {
        path: '/manageUser/assets',
        name: 'assets',
        meta: { title: '资产管理', icon: 'assets', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/user/assets')
      },
      {
        path: '/manage/materialDirection',
        name: 'materialDirection',
        meta: { title: '素材风向标', icon: 'direction', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/materialDirection/materialDirection')
      },
      {
        path: '/manage/feedback',
        name: 'feedback',
        meta: { title: '反馈建议', icon: 'feedback', keepAlive: false },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/feedback/feedback')
      },
      {
        path: '/manage/help',
        name: 'help',
        meta: { title: '用户帮助', icon: 'help' },
        component: () => import(/* webpackChunkName: "manage" */'@/views/manage/help')
      },
      {
        path: '/texture/imageUpload',
        name: 'imageUpload',
        hidden: true,
        component: () => import(/* webpackChunkName: "manage" */'@/views/texture/image'),
        meta: { title: '素材上传', keepAlive: false }
      },
      {
        path: '/texture/personUpload',
        name: 'personUpload',
        hidden: true,
        component: () => import(/* webpackChunkName: "manage" */'@/views/texture/personUpload'),
        meta: { title: '人物素材上传', keepAlive: false }
      },

      { path: '/manage/userAuthentication',
        name: 'userAuthentication',
        hidden: true,
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserAuthentication'),
        meta: { title: '用户认证' }
      },
      {
        path: '/manageUser',
        name: 'manageUser',
        hidden: true,
        redirect: '/manageUser/account',
        component: RouteView,
        meta: { title: '用户管理', keepAlive: false },
        children: [
          {
            path: '/manageUser/account',
            name: 'account',
            hidden: true,
            meta: { title: '账号信息', keepAlive: false },
            component: () => import(/* webpackChunkName: "manage" */'@/views/manage/user/account')
          },
          {
            path: '/manageUser/assets',
            name: 'assets',
            hidden: true,
            meta: { title: '资产管理', keepAlive: false },
            component: () => import(/* webpackChunkName: "manage" */'@/views/manage/user/assets')
          },
          {
            path: '/manageUser/withdraw',
            name: 'withdraw',
            hidden: true,
            meta: { title: '提现流程', keepAlive: false },
            component: () => import(/* webpackChunkName: "manage" */'@/views/manage/user/withdraw')
          },
          {
            path: '/manageUser/bindAliPay',
            name: 'bindAliPay',
            hidden: true,
            meta: { title: '绑定支付宝', keepAlive: false },
            component: () => import(/* webpackChunkName: "manage" */'@/views/manage/user/bindAliPay')
          }
        ]
      }
    ]
  }
]

const notFoundRouter = {
  path: '*',
  name: 'notFound',
  meta: { title: 'notFound' },
  redirect: '/404',
  hidden: true
}

// 基础路由
const constantRouterMap = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "homePage" */ '@/views/homePage/homePage'),
    title: '首页',
    meta: { title: '首页' },
    children: [
      // {
      //   path: '/manage',
      //   name: 'manage',
      //   component: antelayouts,
      //   redirect: '/manage/chartlet',
      //   hidden: true,
      //   children: [
      //     {
      //       path: 'chartlet',
      //       name: 'chartlet',
      //       component: () => import('@/views/manage/chartlet'),
      //       meta: { title: '非人物素材管理' }
      //     },
      //     {
      //       path: 'person',
      //       name: 'person',
      //       component: () => import('@/views/manage/person'),
      //       meta: { title: '人物素材管理' }
      //     }
      //   ]
      // },

    ]
  },

  {
    path: '/page',
    name: 'page',
    component: pageLayout,
    hidden: true,
    children: [{
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "user" */'@/views/agreement/agreement'),
      meta: { title: '用户协议' }
    }]

  },
  {
    path: '/user',
    name: 'user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      { path: 'login', name: 'login', component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'), meta: { title: 'M Art 道具馆' } },
      { path: 'register', name: 'register', component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register'), meta: { title: 'M Art 道具馆' } },
      { path: 'resetPassword', name: 'resetPassword', component: () => import(/* webpackChunkName: "user" */ '@/views/user/resetPassword'), meta: { title: 'M Art 道具馆' } },
      { path: 'registerResult', name: 'registerResult', component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult'), meta: { title: 'M Art 道具馆', keepAlive: false } }

    ]
  },
  {
    path: '/exception',
    name: 'exception',
    component: RouteView,
    hidden: true,
    redirect: '/exception/403',
    meta: { title: '异常页', icon: 'warning', permission: ['exception'] },
    children: [
      {
        path: '/exception/403',
        name: 'exception403',
        component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/403'),
        meta: { title: '403', permission: ['exception'] }
      },
      {
        path: '/exception/404',
        name: 'exception404',
        component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/404'),
        meta: { title: '404', permission: ['exception'] }
      },
      {
        path: '/exception/500',
        name: 'exception500',
        component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/500'),
        meta: { title: '500', permission: ['exception'] }
      }
    ]
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import(/* webpackChunkName: "homePage" */ '@/views/homePage/homePage'),
    hidden: true
  },
  {
    path: '/personEditor',
    name: 'personEditor',
    hidden: true,
    component: () => import(/* webpackChunkName: "manage" */'@/views/texture/personEditor'),
    meta: { title: '人物编辑器', keepAlive: false }
  },
  {
    path: '/wow',
    name: 'wow',
    hidden: true,
    component: () => import(/* webpackChunkName: "wow" */'@/views/h5/wow'),
    meta: { title: 'wow人设', keepAlive: false }
  },
  {
    path: '/wowShare',
    name: 'wowShare',
    hidden: true,
    component: () => import(/* webpackChunkName: "wow" */'@/views/h5/wowShare'),
    meta: { title: 'wow人设', keepAlive: false }
  },
  { path: '/404', name: '404', meta: { title: '404' }, component: () => import(/* webpackChunkName: "exception" */ '@/views/exception/404') }
]

export { constantRouterComponents, notFoundRouter, constantRouterMap }
